module.exports = __webpack_public_path__ + "img/2.5d_5.913a6eb8.jpg";